<template>
    <div class="c-special">
        <div class="row mb-3 c-special__images">
            <div v-for="product in products" class="col-6 col-sm-3 mb-5 c-special__image-data">
                <div v-bind:href="product.url" class="c-special__image" v-bind:style="{ backgroundImage: 'url(' + product.image + ')' }"></div>
                <div v-bind:href="product.url" class="c-special__title">
                    {{ product.model }}
                </div>
            </div>
        </div>

        <table class="w-100 mt-5">
            <thead class="w-100">
            <tr>
                <th>{{ 'messages.model' | trans }}</th>
                <th v-for="attribute in attributes">
                    {{ attribute.title }}
                </th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="product in products">
                    <td>{{ product.model }}</td>

                    <td v-for="attribute in attributes">
                        <span v-if="product.attributes.includes(attribute.id)">{{ product.values[attribute.id]}}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="c-special__documents">
            <h5 class="mt-5 mb-4 text-center">{{ 'messages.documents' | trans }}</h5>
            <div v-for="product in products" class="col-12 mb-1">
                <div class="row mb-3" v-if="product.documents.length != 0">
                    <div class="col-2"><strong>{{ product.model }}:</strong> </div>
                        <div v-for="document in product.documents" class="col-2">
                            <a v-bind:href="document.original_file" target="_blank">
                                {{ document.name }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['categoryId'],
        created() {
            this.getAttributes();
            this.getProducts();
        },
        data() {
            return {
                activeFilters: [],
                attributes: [],
                col: null,
                products: [],
            }
        },

        methods: {
            getAttributes: function () {
                axios
                    .get(route('ajax.getAttributes', this.categoryId))
                    .then(response => {
                        this.attributes = response.data;
                    });
            },
            getProducts: function (search = null) {
                axios
                    .get(route('ajax.getSpecials', this.categoryId))
                    .then(response => {
                        this.products = response.data;
                    });
            },
        }
    }
</script>
